import { render, staticRenderFns } from "./InlineTextareaEditor.vue?vue&type=template&id=d9d5a0c6&scoped=true&lang=html&"
import script from "./InlineTextareaEditor.vue?vue&type=script&lang=js&"
export * from "./InlineTextareaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5a0c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
